/* eslint-disable react/prop-types */
import React from 'react';
import styles from './page-header.less';

const PageHeader = ({ children }) => (
  <div className={styles.Header}>{children}</div>
);

export default PageHeader;
